import { useEffect } from 'react';
import { getCompanyBranding } from '../utils/company';

export function useCareerMetadata(title: string, description: string) {
  const brand = getCompanyBranding().name;
  useEffect(() => {
    const previousTitle = document.title;
    const existing = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const meta = existing ?? document.createElement('meta');
    const previousDescription = meta.content;
    document.title = `${title} · ${brand}`;
    meta.name = 'description';
    meta.content = description;
    if (!existing) document.head.appendChild(meta);
    return () => { document.title = previousTitle; if (existing) meta.content = previousDescription; else meta.remove(); };
  }, [title, description, brand]);
}
